export default __webpack_public_path__ + "static/media/57t.35daf373.jpg";